import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import profileImage from './../../img/profile-photo.png';

export default class Index extends React.Component<RouteComponentProps<{}>, {}> {
    public render() {
        return <div className="container">
            <div className="animated fadeIn">
                <div className="breadcrumb-block clearfix">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                        <li className="breadcrumb-item active">My account</li>
                    </ol>
                    <span className="text-right current-date">4:14, Thursday, June 22, 2017</span>
                </div>
                <div className="user-actions clearfix">
                    <figure className="profile-photo">
                        <img src={profileImage} alt="Profile Photo" title="Profile Photo" />
                    </figure>
                    <div className="user-details">
                        <h4 className="display-name">Steven Hoffman</h4>
                        <span className="user-type">Support Staff</span>
                        <Link to="/account/settings" className="edit-profile">Account Settings</Link>
                    </div>
                </div>
                <div className="card card--datatables">
                    <div className="card-block">
                        <h2 className="card__title">Recent Projects</h2>
                        <div className="datatable-wrapper">
                            <div className="datatable-actions">
                                <div className="btn btn--bulk">
                                    <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                        Buk Action <i className="icon-arrow-down"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-left">
                                        <a className="dropdown-item" href="#">Mark as Delete</a>
                                        <a className="dropdown-item" href="#">Archive Project</a>
                                        <a className="dropdown-item" href="#">Mark as Awarded</a>
                                    </div>
                                </div>
                                <a href="#" className="btn btn--adduser">
                                    <i className="icon-user"></i> Add Project
                                </a>
                                <a href="#" className="btn btn--calendar">
                                    <i className="icon-calendar"></i> March 11, 2017 -  April 11, 2017
                                </a>
                            </div>
                            <table className="table datatable dt-responsive nowrap" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th className="arrow-hidden"></th>
                                        <th>Status</th>
                                        <th>Project ID</th>
                                        <th>BID Date</th>
                                        <th>Project Name</th>
                                        <th>Type</th>
                                        <th>IN - ID</th>
                                        <th>SP - ID</th>
                                        <th className="arrow-hidden"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-cancelled"></i>Cancelled<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-draft"></i>Draft<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-in-progress"></i>In Progress<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-archive"></i>Archive<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-cancelled"></i>Cancelled<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-draft"></i>Draft<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-in-progress"></i>In Progress<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-archive"></i>Archive<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-archive"></i>Archive<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-award"></i>Awarded</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>J2626</td>
                                        <td>13/12/2016</td>
                                        <td>Project Name</td>
                                        <td>Public</td>
                                        <td>IN2256</td>
                                        <td>NO</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="card card--datatables">
                    <div className="card-block">
                        <h2 className="card__title">Recent Quotes</h2>
                        <div className="datatable-wrapper">
                            <div className="datatable-actions">
                                <div className="btn btn--bulk">
                                    <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                        Buk Action <i className="icon-arrow-down"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-left">
                                        <a className="dropdown-item" href="#">Mark as Delete</a>
                                        <a className="dropdown-item" href="#">Archive Project</a>
                                        <a className="dropdown-item" href="#">Mark as Awarded</a>
                                    </div>
                                </div>
                                <a href="#" className="btn btn--calendar">
                                    <i className="icon-calendar"></i> March 11, 2017 -  April 11, 2017
                                </a>
                            </div>
                            <table className="table datatable dt-responsive nowrap" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th className="arrow-hidden"></th>
                                        <th>Status</th>
                                        <th>Quotes ID</th>
                                        <th>BID Date</th>
                                        <th>Name</th>
                                        <th>Created by</th>
                                        <th className="arrow-hidden"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><input name="check[]" type="checkbox" /></td>
                                        <td>
                                            <div className="status-dropdown">
                                                <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                                    <i className="left-ico icon-award"></i>Awarded<i className="icon-arrow-down"></i>
                                                </a>
                                                <div className="dropdown-menu dropdown-menu-left">
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-draft"></i>Draft</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-cancelled"></i>Cancelled</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-in-progress"></i>In Progress</a>
                                                    <a className="dropdown-item" href="#"><i className="left-ico icon-archive"></i>Archive</a>
                                                </div>
                                            </div>
                                        </td>
                                        <td>Q2548</td>
                                        <td>13/12/2016</td>
                                        <td>Brent Materials Company</td>
                                        <td>John</td>
                                        <td>
                                            <a className="btn-edit" href="#">
                                                <i className="icon-edit "></i>
                                            </a>
                                            <a className="btn-delete" href="#">
                                                <i className="icon-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/account/Index.tsx